.vc-mutual-gdms-modal-tab-bar {
    gap: 0;
}

.vc-mutual-gdms-modal-v2-tab-bar {
    --space-xl: 16px;
}
